__webpack_require__.p = "https://cdn.n-tv.de/sport/0.77.0/_next/";